export default {
	"billConfirm": {
		"PackingQty": "Quantity of goods",
		"settlementStatus": "billing status",
		"keywords": "Key words",
		"isConfirm": "confirm",
		"isAdjust": "whether to adjust",
		"isAbnormal": "Is it abnormal",
		"billPrice": "amount",
		"routeBill": "Dispatch bill",
		"billconfirmdeliverVehicleType": "Operation type",
		"fixWorkAmount": "Current business volume",
		"serviceDepartment": "work unit",
		"billingAmount": "Billing amount",
		"billingResource": "Billing source",
		"correctionItemsTitle": "Waybill job data correction",
		"errorMessageTips": "Error message"
	},
	"billReconciliation": {
		"printHandleDetail": "print details",
		"chooseBillTips": "Select the data to be exported in the bill",
		"sendWeight": "Actual weight",
		"receiptWeight": "actual weight",
		"locationNumber": "number of locations",
		"billPrinting": "Bill printing",
		"addPartner": "Add a partner",
		"addSize": "add site",
		"addUser": "Add User",
		"addRoles": "Add Role",
		"printDataChooseTips": "Please tick print data"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/billPayable/billPayable.js